import React, {useRef} from 'react'
import {HStack, Button, Text} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import {GiftBoxIcon} from '../icons'
import {useAddGiftToBabylist} from '../../babylist-api'
import PropTypes from 'prop-types'

const AddToBabylist = ({product}) => {
    const {formatMessage} = useIntl()
    const babylistBtnRef = useRef(null)
    const {enabled, execute, loading} = useAddGiftToBabylist(product, babylistBtnRef)

    if (!enabled) {
        return null
    }

    return (
        <HStack w="100%" justify={'center'} pb={{base: 2, md: 0}}>
            <Button variant="babyList" onClick={execute} ref={babylistBtnRef} isDisabled={loading}>
                <HStack spacing={2} align="center">
                    <Text>
                        {formatMessage({
                            id: 'product_detail.link.add_to_babylist',
                            defaultMessage: 'Add to Babylist'
                        })}
                    </Text>
                    <GiftBoxIcon boxSize={4} />
                </HStack>
            </Button>
        </HStack>
    )
}

AddToBabylist.propTypes = {
    product: PropTypes.object
}

export default AddToBabylist
